// extracted by mini-css-extract-plugin
module.exports = {"opcDetail":"opcDetail_opcDetail__kvhUc","opcDetailTitle":"opcDetail_opcDetailTitle__UqHXQ","loading":"opcDetail_loading__IFzXk","nothing":"opcDetail_nothing__uYLsE"};